export default __webpack_public_path__ + "static/media/codefi1.6e9d0060.png";